import { type FC } from 'react';
import { Widget } from '../../widget';
import RiskMetricContent from './risk-metric-content';
import { RiskMetricProps } from './types';

const RiskMetricWidget: FC<RiskMetricProps> = (props) => {
  const { widget, id, minIndex, maxIndex } = props;

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
      </Widget.Header>
      <Widget.Content>
        <RiskMetricContent id={id} minIndex={minIndex} maxIndex={maxIndex} />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
};

export default RiskMetricWidget;
